"use client";

import useIsDesktop from "@/hooks/useIsDesktop";
import { useServerDevice } from "@/contexts/ServerDevice";
import { ImagesOnlyOn } from "@core/helpers/client/contexts/ImagePriorityContext";

// A mobile-only or desktop-only copy of a block (`lg:hidden` / `hidden lg:block`) that is left out of the server
// HTML when the User-Agent says it is for the other device. Both copies used to be in every page's HTML: on the home
// page that was ~1,150 of ~2,400 elements a visitor never sees.
//
// - Server + hydration: only the copy for the UA's device; tablets and unknown agents get both (as before). The
//   value comes from ServerDeviceProvider, so the hydration pass renders exactly what the server sent.
// - After hydration the real viewport decides (useIsDesktop): a desktop browser in a narrow window, or a phone asking
//   for the desktop site, switches to the right copy then.
// Images inside keep ImagesOnlyOn, so on a tablet the copy for the other side stays lazy.
//
// Use it only where both copies carry the same content and links: a crawler gets the copy for its own UA.
export default function DeviceOnly({ on, children }) {
	const is_desktop = useIsDesktop();
	const server_device = useServerDevice();

	const show = is_desktop === null
		? !server_device || server_device === on
		: (on === "desktop") === is_desktop;

	if (!show) return null;
	return <ImagesOnlyOn device={on}>{children}</ImagesOnlyOn>;
}
